<template>
  <BaseModal
    :is-open="isOpen"
    :show-default-footer="false"
    :close-on-overlay-click="false"
    showCloseButton
    content-padding="none"
    size="md"
    title="서류 제출"
    @close="emit('close')"
    @update:is-open="emit('update:isOpen', $event)"
  >
    <div class="flex flex-col items-center gap-9 px-12 py-10">
      <div class="flex flex-col items-center gap-4">
        <div class="flex h-[100px] w-[100px] items-center justify-center">
          <img :src="documentCheckImage" alt="계좌 개설" class="h-full w-full object-contain" />
        </div>

        <div class="flex flex-col items-center gap-3 text-center">
          <p class="text-base font-medium leading-5 tracking-[-0.35px] text-[var(--popup-text)]">
            실전 투자를 미리 준비해 볼까요?
          </p>
          <p class="text-sm font-normal leading-[18px] tracking-[-0.35px] text-[var(--popup-text)]">
            서류 제출을 완료하고 실거래를 시작해보세요!
          </p>
        </div>
      </div>

      <BaseButton
        label="서류 제출하러 가기"
        variant="contained"
        color="primary"
        size="lg"
        custom-class="w-[360px]"
        @click="emit('submitDocuments')"
      />
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { BaseModal, BaseButton, documentCheckImage } from '@template/ui';

interface Props {
  isOpen: boolean;
}

interface Emits {
  (e: 'close'): void;
  (e: 'submitDocuments'): void;
  (e: 'update:isOpen', value: boolean): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
</script>
